'use strict'

import React, { useEffect, useState } from 'react'
import './SortList.css'

function SortList (props) {
  //console.info(props)
  const sortVariants = [
    {sort: 'relevance', order: 'asc', title: 'SORT_RELEVANCE'},
    {sort: 'created_at', order: 'desc', title: 'SORT_NEW'},
    {sort: 'price', order: 'asc', title: 'SORT_CHEAPER'},
    {sort: 'price', order: 'desc', title: 'SORT_EXPENSIVE'},
  ]

  const [showVariants, setShowVariants] = useState(false)
  const sortList = () => {
    let list = []

    sortVariants.map(sortVariant => {
      let active = sortVariant.sort === props.ordering.sort && sortVariant.order === props.ordering.order
      list.push(<li key={`${sortVariant.sort}-${sortVariant.order}`} className={active ? 'active' : ''}
                    onClick={event => {
                      props.onChange(sortVariant.sort, sortVariant.order)
                      setShowVariants(false)
                    }}>{props.getMessage(sortVariant.title)}</li>)
    })

    return list
  }

  const activeSortTitle = () => {
    let title = 'undefined'

    for (let sortVariant of sortVariants) {
      if (sortVariant.sort !== props.ordering.sort || sortVariant.order !== props.ordering.order) continue
      title = props.getMessage(sortVariant.title)
      break
    }

    return title
  }

  return (
    <div className="ordering mr-auto float-left !ml-0 desktop:!ml-auto desktop:!mr-0 desktop:float-right">
      <span className={'sort-current'} onClick={() => {setShowVariants(!showVariants)}}>{activeSortTitle()}</span>
      <span className={'sort-arrow'} onClick={() => {setShowVariants(!showVariants)}}/>
      {
        showVariants ?
          <ul className={'sort-variants'}>{sortList()}</ul> :
          <></>
      }
    </div>
  )
}

export default SortList